import * as api from './create-account-api';
import { setPasswordRules } from './create-account-action-creator';
import { loginRequest } from '../../auth/auth-middleware';
import * as MsgBarActions from '../../system-shared/message-bar-action-creator';
import { callWithLoadingIndicator } from '../../loading-indicator/loading-indicator-middleware';

let isSentConfirmEmail = false;

export const submitCreateAccount = (accountInformation, language) => (dispatch) =>
  dispatch(callWithLoadingIndicator(
    'CreateAccount',
    () => api.postCreateAccount(accountInformation, language)
  ))
    .then((response) => {
      isSentConfirmEmail = response === undefined || response.data !== 'Failed to send email';
      dispatch(loginRequest(
        { username: accountInformation.username,
          password: accountInformation.password }, '/', true));
    })
    .then(() => {
      if (accountInformation.encryptedInvitationId) {
        dispatch(MsgBarActions.showStickySuccessMessage('arSignupSuccess'));
      } else if (!isSentConfirmEmail) {
        dispatch(MsgBarActions.showStickySuccessMessage('signupSuccessCantSendEmail'));
      } else {
        dispatch(MsgBarActions.showStickySuccessMessage('signupSuccess', [accountInformation.emailAddress]));
      }
    })
    .catch((axiosResponse) => {
      const error = axiosResponse.response;
      if (error.data.message === 'username_exists') {
        dispatch(MsgBarActions.showErrorMessage('signUpAccountInformationDuplicateName'));
      } else {
        dispatch(MsgBarActions.showErrorMessage('signupFailed'));
      }
    });

export const loadPasswordRules = () => (dispatch) => (
  api.getPasswordRules()
    .then((response) => {
      dispatch(setPasswordRules(response.data));
    })
);
